export { default } from "./CustomScroll.vue";
